import React from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import rTurnLogo from 'assets/impact-report/rTurn-logo.png';

// Create styles
const styles = StyleSheet.create({
  section: {},
  header: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '0px 50px 20px',
    fontFamily: 'Trebuchet',
    fontWeight: 'bold',
    position: 'relative',
  },
  headerTextContr: {
    position: 'relative',
  },
  headerText: {
    position: 'absolute',
    width: 440,
    fontSize: 32,
    color: '#FFFCE8',
    paddingLeft: 20,
    paddingTop: 20,
    paddingBottom: 20,
    borderLeftWidth: 2,
    borderColor: '#fff',
    fontFamily: 'Trebuchet',
    fontWeight: 'bold',
  },
  logo: {
    width: 90,
    height: 80,
    marginRight: 20,
  },
  custLogo: {
    height: 60,
    width: 'auto',
  },
  section2: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    height: 72,
    fontFamily: 'Trebuchet',
    fontWeight: 'bold',
  },
  name: {
    color: '#53575A',
    fontFamily: 'Trebuchet',
    fontWeight: 'bold',
    flex: 1,
    textAlign: 'center',
    paddingHorizontal: 10,
  },
  logoContainer: {
    justifyContent: 'center',
  },
});

type PdfHarvestSummaryReportProps = {
  reportData: any;
};

const headerText = 'Reuse Summary Report';

const Header = ({ reportData }: PdfHarvestSummaryReportProps) => {
  const imageSrc = `https://rturn${
    process.env.REACT_APP_ENVIRONMENT === 'dev' ? '-dev' : ''
  }.s3.amazonaws.com`;

  return (
    <>
      <View style={styles.section}>
        <View style={styles.header}>
          <Image style={styles.logo} src={rTurnLogo} />
          <View style={styles.headerTextContr}>
            <Text style={{ ...styles.headerText, top: 2, color: '#bf9e00' }}>
              {headerText}
            </Text>
            <Text style={styles.headerText}>{headerText}</Text>
          </View>
        </View>
      </View>
      <View style={styles.section2}>
        <Text style={styles.name}>{reportData?.site?.name}</Text>
        {reportData.customerDetails?.logo !== '' ? (
          <View style={styles.logoContainer}>
            <Image
              style={styles.custLogo}
              src={`${imageSrc}/${reportData.customerDetails?.logo}`}
            />
          </View>
        ) : (
          <View style={{ height: '138px' }} />
        )}
        <Text style={styles.name}>{reportData?.name}</Text>
      </View>
    </>
  );
};

export default Header;
